import { render, staticRenderFns } from "./connectionRecords.vue?vue&type=template&id=ad2d6f0a&scoped=true&"
import script from "./connectionRecords.vue?vue&type=script&lang=js&"
export * from "./connectionRecords.vue?vue&type=script&lang=js&"
import style0 from "./connectionRecords.vue?vue&type=style&index=0&id=ad2d6f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2d6f0a",
  null
  
)

export default component.exports